module.exports = __webpack_public_path__ + "static/media/triplec-interreg-2-seas-mers-zeeen-vertical.e0192780.jpg";